/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hi",
  title2: " I'm Sumit Sharma",
  logo_name: "Sumit Sharma",
  // nickname: "",
  full_name: "Sumit Sharma",
  subTitle1: "Software Developer.",
  subTitle2: "Full Stack Developer.",
  subTitle: "Full Stack Developer, Life Long Learner.",
  // resumeLink:
  //   "https://drive.google.com/file/d/1-SSCPhVG80IDtpx7_TPpsLfJyEA7NEtv/view?usp=drive_link",
  mail: "mailto:sumitsharma9968@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/sumit-sharma-02",
  linkedin: "https://www.linkedin.com/in/sumitsharma002",
  gmail: "sumitsharma9968@gmail.com",
  twitter: "https://twitter.com/sumitsharma002",
};

const skills = {
  data: [
    {
      _id: "354c54b7-ffd8-40f1-972f-1d006733df25",
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive user interfaces and seamless backend integration for high-performance web applications.",
        "⚡ Built responsive and accessible frontends using modern frameworks like React.js and Next.js",
        "⚡ Developed robust and scalable backends using Django, Node.js, Express, Snowflake, SQL, and MongoDB.",
        "⚡ Integration of AWS services such as AWS Lambda, S3, serverless functions and secrets manager.",
      ],
      softwareSkills: [
        {
          skillName: "React.js",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "logos:nextjs-icon",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#593D88",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#0e3b2c",
          },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "logos:snowflake-icon",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            color: "#f4f2ed",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0769ad",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs-icon",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "gray",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Material UI",
          fontAwesomeClassname: "simple-icons:uikit",
          style: {
            color: "#007FFF",
          },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "logos:tailwindcss-icon",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Framer Motion",
          fontAwesomeClassname: "logos:framer",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Styled Components",
          fontAwesomeClassname: "vscode-icons:file-type-styled",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Cloudinary",
          fontAwesomeClassname: "logos:cloudinary-icon",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Stripe",
          fontAwesomeClassname: "logos:stripe",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        }
      ],
    },
    {
      _id: "c026fe64-1542-42b0-84ab-9311840c169f",
      title: "Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience in deploying and managing applications across multiple cloud platforms, including AWS, Firebase and Vercel.",
        "⚡ Experience implementing Continuous Integration (CI) pipelines for streamlined development.",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            color: "#f4f2ed",
          },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "logos:snowflake-icon",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "MongoDB Atlas",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "skill-icons:vercel-light",
          style: {
            color: "gray",
            fill: "gray",
            // backgroundColor: "white",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
            width: "1em",
            height: "1em",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Amrita Vishwa Vidyapeetham, Coimbatore",
      subtitle: "Masters in Computer Applications (MCA)",
      logo_path: "amrita_logo.png",
      alt_name: "Amrita University",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have taken varity of courses related to Artificial Intelligence, Machine Learning, Computer Vision etc.",
        "⚡ Apart from this, I have done courses on Cloud Computing and Full Stack Development.",
      ],
      website_link: "https://www.amrita.edu/",
    },
    {
      title: "Guru Gobind Singh Indraprastha University, New Delhi",
      subtitle: "Bachelors in Computer Applications (BCA)",
      logo_path: "ggsipu_logo.png",
      alt_name: "GGSIPU",
      duration: "2018 - 2021",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        // "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development."
      ],
      website_link: "http://www.ipu.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Fractal Data Science",
      subtitle: "",
      logo_path: "fractal-logo.jpg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/T0I5BS0WV9T2",
      alt_name: "Fractal",
      color_code: "#ffffff"
    },
    {
      title: "SQL Developer Associate",
      subtitle: "",
      logo_path: "fractal-logo.jpg",
      certificate_link:
        "https://www.credential.net/a4f742e4-872c-4657-a49d-ccd81646d870#acc.dvtcMsQJ",
      alt_name: "Fractal",
      color_code: "#ffffff"
    },
    {
      title: "Generative AI for Developers",
      subtitle: "",
      logo_path: "fractal-logo.jpg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/8U6OUJR37YLB",
      alt_name: "Fractal",
      color_code: "#ffffff"
    },
    {
      title: "IBM Full Stack Software Developer",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/cbcd30865e98e2e45161a6ace19d3558",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Application Development using Microservices and Serverless",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/4fa1b8d2f654495a0b692b65d9964ad5",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Introduction to Cloud Computing",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/438a8e16af4786782c8a739aef79e999",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Introduction to Containers w/ Docker, Kubernetes & OpenShift",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/cfa7b88b913e4a8446b9dc706c0802b0",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Django Application Development with SQL and Databases",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/47d8c39642888094ad458b5e44a3c9f3",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Developing AI Applications with Python and Flask",
      subtitle: "",
      logo_path: "ibm_logo.jpg",
      certificate_link:
        "https://coursera.org/share/f4ce59c0d68e4569056faaf2fdb4c256",
      alt_name: "IBM",
      color_code: "#096ce1",
    },
    {
      title: "Frontend Developer Capstone",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/f80912b58e3afcfa49e6116210a2c9da",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Advanced React",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/877acd7eaf9dd532a2cb5b103576967e",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Java Programming: Build a Recommendation System",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/6af001cafc4b683bb38abdb9e81d0d79",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "React Basics",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/29c75a387fcaf2f1e2403f73473092b2",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Programming with JavaScript",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/cb44f1ee2db3f50b83a56cbae15fcc74",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "HTML and CSS in depth",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "https://coursera.org/share/667de02731a480b76b5300c6612d174d",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Java Programming: Principles of Software Design",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/f4e9af47fbb24381e04031f3cc8cfd9f",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Java Programming: Solving Problems with Software",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/36411fcea7ea4fbb5c613ef4911f4668",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Programming Foundations with JavaScript, HTML and CSS",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "https://coursera.org/share/0269c76c33997304d1842d4eef16815b",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Android Application Development - II",
      subtitle: "- Dr. Adam Porter",
      logo_path: "maryland_logo.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/GN48B7W9TU59",
      alt_name: "Stanford University",
      color_code: "#e11a2b",
    },
    {
      title: "Android Application Development - I",
      subtitle: "- Dr. Adam Porter",
      logo_path: "maryland_logo.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/2H59Z22DDSU8",
      alt_name: "Stanford University",
      color_code: "#e11a2b",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Christian Hur",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/97WF8EZ4Y2YD",
      alt_name: "Coursera",
      color_code: "#0056d2",
    },
    {
      title: "ML and AI in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2862832",
      alt_name: "GCP",
      color_code: "#2fa9508a",
    },
    {
      title: "Foundational Infrastructure in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2653409",
      alt_name: "GCP",
      color_code: "#4087f08a",
    },
    {
      title: "Networking & Security in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2510430",
      alt_name: "GCP",
      color_code: "#eb40308a",
    },
    {
      title: "Cloud Computing Fundamentals in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/345a17d9-689f-4154-a3d3-c0396c98b3bc/badges/2469792",
      alt_name: "GCP",
      color_code: "#fabd008a",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Career Highlights",
  description:
    "With over 4+ years of experience as a Full Stack Developer, I have built scalable, user-centric products for diverse stakeholders at Infosys, Ottonomy, and Fractal. My work spans multiple domains including Robotics, CPG(Consumer Packaged Goods), Retail, and Education.",
  header_image_path: "experience.svg",
  sections: {
    title: "Work Experience",
    experiences: [
      {
        title: "SDE 2",
        company: "Fractal",
        company_url: "https://fractal.ai/",
        logo_path: "fractal-logo.jpg",
        alt_name: "fractal-logo",
        duration: "(April, 2024 - Present)",
        location: "Gurugram (Remote)",
        description: "Working on creating products under CPG and Retail Domain.",
        // description: "<li> Developed so and so things.... </li><br><li>Implemented so and so things.... </li>", // For Bullet Points
        color: "#ffffff",
      },
      {
        title: "SDE 1",
        company: "Ottonomy",
        company_url: "https://ottonomy.io/",
        logo_path: "ottonomy-logo.webp",
        alt_name: "ottonomy-logo",
        duration: "(May, 2023 - April, 2024)",
        location: "Gurugram (Hybrid)",
        description: "Worked on creating various products under Robotics Domain such as E-com app to place orders via robots, app to schedule various advertisements on robots display and app to operate the robot with joystick controller.",
        color: "#000000",
      },
      {
        title: "Senior System Associate",
        company: "Infosys",
        company_url: "https://www.infosys.com/",
        logo_path: "infosys-logo.png",
        alt_name: "infosys-logo",
        duration: "(Aug, 2021 - May, 2023)",
        location: "Mysore (Remote)",
        description: "Worked on creating products under Education domain to enhance learner's user experience in learning something online by adding hover-based, trigger-based animations or to add illustrations for certain analogies.",
        color: "#0071C5",
      },
    ],
  },
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage a wide range of modern technologies, with a strong emphasis on building robust and scalable full-stack applications. My core expertise lies in developing MERN (MongoDB, Express, React, Node.js) and Django-based full stack projects. Below are some of the key projects I’ve worked on.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "project-0",
      name: "Portfolio",
      url: "",
      repoUrl: "https://github.com/sumit-sharma-02/sumit-portfolio",
      description: "You are watching it right now 😉.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "React Reveal",
          iconifyClass: "simple-icons:scrollreveal",
        },
        {
          name: "Styled Components",
          iconifyClass: "vscode-icons:file-type-styled",
        },
      ],
    },
    {
      id: "project-1",
      name: "Crafty Commerce",
      url: "https://crafty-commerce.vercel.app/",
      repoUrl: "https://github.com/sumit-sharma-02/crafty-commerce",
      description:
        "Crafty Commerce is a full stack e-commerce web application that allows you to purchase different categories of product online. You can apply filters accordingly and find your favourite products in crafty commerce. You can pay with debit/credit cards and in just few click your product will be delivered.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Redux",
          iconifyClass: "logos:redux",
        },
        {
          name: "Express",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "Nodejs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Stripe",
          iconifyClass: "logos:stripe",
        },
        {
          name: "Tailwind",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Cloudinary",
          iconifyClass: "logos:cloudinary-icon",
        },
        {
          name: "Framer Motion",
          iconifyClass: "logos:framer",
        },
      ],
    },
    {
      id: "project-2",
      name: "Little Lemon Restaurant",
      url: "https://little-lemon-restaurant-sumit-sharma-02.vercel.app/",
      repoUrl: "https://github.com/sumit-sharma-02/little-lemon-restaurant",
      description:
        "Final capstone project for Meta Front-end developer program on Coursera, which contains a detailed and responsive website with table-booking functionality built using React.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        }
      ],
    },
    {
      id: "project-3",
      name: "Tikkaway",
      url: "https://restaurant-app-bceb0.web.app/",
      repoUrl: "https://github.com/sumit-sharma-02/tikkaway",
      description:
        "Tikkaway is a full stack restaurant web application that allows you to order food online. It has wide variety of categories on the menu like Chicken, Curry, Rice, Fish, Fruits, Icecreams, Soft Drinks etc.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Redux",
          iconifyClass: "logos:redux",
        },
        {
          name: "Firebase",
          iconifyClass: "logos:firebase",
        },
        {
          name: "Tailwind",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Framer Motion",
          iconifyClass: "logos:framer",
        },
      ],
    },
    {
      id: "project-4",
      name: "SpaceX Capsules",
      url: "https://spacex-capsules.vercel.app/",
      repoUrl: "https://github.com/sumit-sharma-02/spacex-capsules",
      description:
        "A React application which shows you the filtered spaceX capsules data.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Redux",
          iconifyClass: "logos:redux",
        },
        {
          name: "Tailwind",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
      ],
    },
    {
      id: "project-5",
      name: "MEAN Agency",
      url: "",
      repoUrl: "https://github.com/sumit-sharma-02/mean-agency",
      description:
        "Mean Agency is a full stack service provider web application that allows you to provide services to other companies.",
      languages: [
        {
          name: "Angular",
          iconifyClass: "logos:angular-icon",
        },
        {
          name: "Express",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "Nodejs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "Handlebars",
          iconifyClass: "vscode-icons:file-type-handlebars",
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "portfolioProfileImage.png",
    description:
      "Feel free to reach out through any of the channels listed below — I’ll get back to you as promptly as possible.",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
